"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const loader_1 = require("components/loader");
const auth_1 = require("modules/auth");
const MembershipService_1 = __importDefault(require("modules/membership/MembershipService"));
const user_1 = require("modules/user");
const audiencePromoteProductUtils_1 = __importDefault(require("./audiencePromoteProductUtils"));
const extensionsUserInfo_1 = require("../extensionsUserInfo");
const AudiencePromoteProduct = ({ showModal, onClose, filters }) => {
    const rootRef = (0, react_1.useRef)(null);
    const [user, setUser] = (0, react_1.useState)();
    const language = user_1.UserService.language;
    const userToken = auth_1.AuthService.token || localStorage.getItem('token');
    const productId = MembershipService_1.default.productId;
    const subdomain = MembershipService_1.default.subdomain;
    (0, react_1.useLayoutEffect)(function renderAppAudience() {
        if (!user) {
            return;
        }
        const options = {
            onClose,
            language,
            showModal,
            user,
            activationSource: 'app-club-admin',
            token: userToken,
            productId,
            filters,
            subdomain
        };
        if (!rootRef.current) {
            return;
        }
        audiencePromoteProductUtils_1.default.renderAsModuleFederation(rootRef.current, options);
    }, [
        onClose,
        language,
        showModal,
        user,
        userToken,
        productId,
        filters,
        subdomain
    ]);
    (0, react_1.useEffect)(() => {
        const fetchUser = async () => {
            if (!user) {
                if (!extensionsUserInfo_1.ExtensionsUserInfoService.extensionsUserInfo.id) {
                    await extensionsUserInfo_1.ExtensionsUserInfoService.fetchExtensionsUserInfoData();
                }
                setUser(extensionsUserInfo_1.ExtensionsUserInfoService.extensionsUserInfo);
            }
        };
        fetchUser();
    }, [user]);
    return ((0, jsx_runtime_1.jsx)("div", { id: "app-audience-root", ref: rootRef, "aria-live": "polite", children: (0, jsx_runtime_1.jsx)(loader_1.Loader, { full: true, mask: true }) }));
};
exports.default = AudiencePromoteProduct;
